module.exports = __webpack_public_path__ + "images/landing-page-1-567192b92e74625d7dc57dcfa05d48d1.jpg";